"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'デジリアトレカ',
    organizationId: 'LLa5moRAgALXCuI2glbU',
    applicationKey: 'digirea',
    applicationType: 'organization',
    artistId: undefined,
    version: '1.7',
    ionicAppId: '1424e533',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'jp.digirea',
        appId: '1573205494',
    },
    android: {
        bundleId: 'jp.digirea',
    },
    deeplinkUrl: 'https://app.digirea.jp',
    helpUrl: 'https://help.utoniq.com/ja/collections/3161857',
    deeplinkDev: 'digirea-dev.netlify.app',
    deeplinkStg: 'digirea-stg.netlify.app',
    deeplinkProd: 'app.digirea.jp',
    custom: {
        modules: {
            tutorial: true,
            trade: true,
            membership: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            nft: true,
            liveStream: true,
            item: true,
            store: true,
            campaign: true,
            mission: true,
            eprint: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: ['home', 'myCollections', 'campaign-events', 'artist'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'threads'],
    },
});
